import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import {Button} from '@mui/material'
import {StyledTableCell, StyledTableRow} from '.'
import TableCellText from './TableCellText'
import {Claim} from './HistoryClaimsTable'

interface ClaimMobileTableProps {
  onClickDownload: (_: any) => any
  data: Array<Claim>
  year: string
}

type MobileTableProps = ClaimMobileTableProps

export default function DesktopTable({onClickDownload, data, year}: MobileTableProps) {
  //
  const yearData = data.filter((claim) => claim.claimyear === year)
  return (
    <TableContainer component={Paper}>
      <Table sx={{minWidth: 700}} aria-label='customized table'>
        <TableHead>
          <TableRow>
            <StyledTableCell>Claim Date</StyledTableCell>
            <StyledTableCell style={{whiteSpace: 'normal', wordBreak: 'break-word'}}>Reason</StyledTableCell>
            <StyledTableCell style={{whiteSpace: 'normal', wordBreak: 'break-word'}}>Tracking Information</StyledTableCell>
            <StyledTableCell>Download</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {yearData &&
            yearData.map((row: Claim, i: number) => (
              <StyledTableRow key={i}>
                <StyledTableCell component='th' scope='row'>
                  {row.created}
                </StyledTableCell>
                <StyledTableCell style={{whiteSpace: 'normal', wordBreak: 'break-word'}}>
                  <TableCellText text={row.comments} />
                </StyledTableCell>
                <StyledTableCell style={{whiteSpace: 'normal', wordBreak: 'break-word'}}>
                  <TableCellText text={row.trackingInformation} />
                </StyledTableCell>
                <StyledTableCell>
                  <div style={{width: '160px'}}>
                    <Button variant='contained' size='small' disableElevation className='rounded-full' onClick={() => onClickDownload(row)}>
                      Download Claim
                    </Button>
                  </div>
                </StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
